import React from 'react';
import Style from './Navbar.module.scss';
import { Link, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { info } from '../assets/info/Info';

const links = [
  {
    name: 'home',
    to: '/',
    active: 'home',
  },
  {
    name: 'about',
    to: '/about',
    active: 'about',
  },
  {
    name: 'experience',
    to: '/experience',
    active: 'experience',
  },
  {
    name: 'technical',
    to: '/technical',
    active: 'technical',
  },
];

export default function Navbar() {
  const location = useLocation();
  // First path segment, so nested routes like /technical/:slug keep their tab highlighted.
  const active = location.pathname.split('/')[1] || 'home';

  return (
    <Box component={'nav'} className={Style.nav}>
      <Box component={'ul'} className={Style.list}>
        <Box component={'li'} className={Style.initialsItem}>
          <Link to={'/'} className={Style.initials} aria-label={'home'}>
            {info.initials}
          </Link>
        </Box>
        {links.map((link, index) => (
          <Box
            key={index}
            component={'li'}
            className={link.active === active ? Style.active : undefined}
          >
            <Link to={link.to} className={Style.link}>
              {link.name}
            </Link>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
